import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { adoptServedHead } from './seo/servedHead';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, CssBaseline } from '@mui/material';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import theme from './theme';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// DYN-260. BEFORE React renders, and before Helmet's first frame. The served
// tags are MARKED as Helmet's and handed to it as defaults, so a page that sets
// its own description replaces this one instead of sitting beside it. They stay
// in the head until Helmet's first flush replaces them, so there is never a
// moment with no metadata at all: an earlier version removed them here and a
// reviewer caught that partial execution would then degrade to nothing.
// Doing it here rather than inside a component keeps it out of render, where
// StrictMode would run it twice and the second run would find nothing to adopt.
const servedHead = adoptServedHead();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App servedHead={servedHead} />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
